export const eWebinarHTMLForm = `
  <div id="w1761735033789" class="ewebinar__Widget ewebinar__RegForm_Root" style="width: 100%;">
    <form class="ewebinar__RegForm ewebinar--ltr">
      <div class="ewebinar__RegForm__Content">
        <div>
          <div id="session" class="ewebinar__RegForm__Field ewebinar__RegForm__Field--Sessions">
            <label class="ewebinar__RegForm__Field__Label" for="session">
            </label>
            <div class="ewebinar__Session__Dropdown" style="color: #ff4e30ff; border-color: #ff4e30ff;">
              <select name="session" id="session" class="ewebinar__Session__Dropdown__Select">
                <option class="ewebinar__FixedBar__Content__Session__Dropdown__Select" value="" disabled="disabled" selected="selected" hidden="">Getting sessions...</option>
              </select>
            </div>
            <div class="ewebinar__RegForm__Field__Error"></div>
          </div>
          <div class="ewebinar__RegForm__Field">
            <label class="ewebinar__RegForm__Field__Label" for="name">Full name <span class="ewebinar__RegForm__Field__Label--required">*</span></label>
            <div class="ewebinar__RegForm__Field__Input">
              <input id="name" name="name" autocomplete="off">
            </div>
            <div class="ewebinar__RegForm__Field__Error"></div>
          </div>
          <div class="ewebinar__RegForm__Field ewebinar__RegForm__Field__Email">
            <label class="ewebinar__RegForm__Field__Label" for="email">Work email <span class="ewebinar__RegForm__Field__Label--required">*</span></label>
            <div class="ewebinar__RegForm__Field__Input">
              <input id="email" name="email" autocomplete="off">
            </div>
            <div class="ewebinar__RegForm__Field__Error"></div>
          </div>
          <div class="ewebinar__RegForm__Field">
            <label class="ewebinar__RegForm__Field__Label" for="company_1">Company <span class="ewebinar__RegForm__Field__Label--required">*</span></label>
            <div class="ewebinar__RegForm__Field__Input">
              <input id="company_1" name="company_1" autocomplete="off">
            </div>
            <div class="ewebinar__RegForm__Field__Error"></div>
          </div>
          <div class="ewebinar__RegForm__Field">
            <label class="ewebinar__RegForm__Field__Label" for="role">Role <span class="ewebinar__RegForm__Field__Label--required">*</span></label>
            <div class="ewebinar__RegForm__Field__Input">
              <input id="role" name="role" autocomplete="off">
            </div>
            <div class="ewebinar__RegForm__Field__Error"></div>
          </div>
          <div class="ewebinar__RegForm__Field ewebinar__RegForm__Field--Consent">
            <div class="ewebinar__RegForm__Field__Input__CheckedConsent">
              <input type="checkbox" name="checkedConsent" id="checkedConsent">
              <label for="checkedConsent">I agree to receive marketing communications about your products and services, including notifications about offers, content, and updates that may contain commercial information.</label>
            </div>
            <div class="ewebinar__RegForm__Field__Error"></div>
          </div>
        </div>
        <div class="ewebinar__RegForm__Captcha"></div>
        <div class="ewebinar__RegForm__Error"></div>
      </div>
      <div class="ewebinar__RegForm__Footer">
        <a class="ewebinar__RegisterButton__Wrap ewebinar--ltr" href="javascript:;" style="text-decoration: none;;">
          <button class="ewebinar__Widget ewebinar__RegisterButton" type="submit" style="border-radius: 50px; background: #ff5e45ff; color: #ffffff;">
            <div class="ewebinar__Dots">
              <span class="ewebinar__LoadingDot" style="background: #ffffff"></span>
              <span class="ewebinar__LoadingDot" style="background: #ffffff"></span>
              <span class="ewebinar__LoadingDot" style="background: #ffffff"></span>
            </div>
            <span class="ewebinar__ButtonText" style="white-space: nowrap;">Sign Up Now</span>
          </button>
        </a>
        <noscript style="display: flex; min-width: fit-content;">
          <div style="text-align: center; margin: 0.5em; text-decoration: none;"><a style="color: #000; font-size: 13px;" href="https://naturaily.com/webinar/why-you-should-migrate-from-magento-to-shopify">Sign Up Now</a></div>
        </noscript>
      </div>
    </form>
  </div>
`;
